/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_SellersInputs */

const en_footer_sellers = /** @type {(inputs: Footer_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace sellers`)
};

const zh_hans1_footer_sellers = /** @type {(inputs: Footer_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场卖家`)
};

const pt_br2_footer_sellers = /** @type {(inputs: Footer_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedores do marketplace`)
};

const es_footer_sellers = /** @type {(inputs: Footer_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedores del marketplace`)
};

const fr_footer_sellers = /** @type {(inputs: Footer_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeurs de la marketplace`)
};

const de_footer_sellers = /** @type {(inputs: Footer_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz-Verkäufer`)
};

const ru_footer_sellers = /** @type {(inputs: Footer_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавцы маркетплейса`)
};

const it_footer_sellers = /** @type {(inputs: Footer_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venditori del marketplace`)
};

/**
* | output |
* | --- |
* | "Marketplace sellers" |
*
* @param {Footer_SellersInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_sellers = /** @type {((inputs?: Footer_SellersInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_SellersInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_sellers(inputs)
	if (locale === "pt-BR") return pt_br2_footer_sellers(inputs)
	if (locale === "es") return es_footer_sellers(inputs)
	if (locale === "fr") return fr_footer_sellers(inputs)
	if (locale === "de") return de_footer_sellers(inputs)
	if (locale === "ru") return ru_footer_sellers(inputs)
	if (locale === "it") return it_footer_sellers(inputs)
	return en_footer_sellers(inputs)
});